import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export const PasswordInput = ({ className = "", testId = "password-input", ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input {...props} data-testid={testId} type={show ? "text" : "password"} className={`pr-11 ${className}`} />
      <button
        type="button"
        data-testid={`${testId}-toggle`}
        aria-label={show ? "Ocultar contraseña" : "Ver contraseña"}
        onClick={() => setShow(s => !s)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-zinc-900 transition-colors"
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};
